export default "__VITE_ASSET__B_Br5FuS__"